<template>
  <Modal v-model="visible" :title="cusTitle" :width="540" :mask-closable="false" class-name="vertical-center-modal">
    <Form :label-width="140">
      <FormItem label="媒体">
        <auto-complete
          v-model="setinfo.mediaId"
          :data="MEDIAS"
          :disabled="edit"
          :width="140"
          :popper-append-to-body="false"
          placeholder="请选择"
          @on-select="handleMedia"
        />
      </FormItem>
      <FormItem label="包体最大限制">
        <input-number-plus v-model="setinfo.maxCapacity" :max="5" :min="1" :width="228" placeholder="请输入分包大小，范围: 1 ~ 32768 " />
        <span class="c-unit"> M</span>
      </FormItem>
      <FormItem label="最低数量限制">
        <input-number-plus v-model="setinfo.minNum" :max="9" :min="1" :width="228" placeholder="请输入最低数量，范围: 1 ~ 999999999 " />
      </FormItem>
      <FormItem label="最高数量限制">
        <input-number-plus v-model="setinfo.maxNum" :max="9" :min="1" :width="228" placeholder="请输入最高数量，范围: 1 ~ 999999999 " />
      </FormItem>
      <FormItem label="IMEI转化">
        <Select v-model="setinfo.imeiType" transfer style="width: 140px">
          <Option v-for="item of equiData" :key="item.id" :value="item.id">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem label="IDFA转化">
        <Select v-model="setinfo.idfaType" transfer style="width: 140px">
          <Option v-for="item of equiData" :key="item.id" :value="item.id">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem label="OAID转化">
        <Select v-model="setinfo.oaidType" transfer style="width: 140px">
          <Option v-for="item of equiData" :key="item.id" :value="item.id">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem label="支持文件格式">
        <Select v-model="setinfo.docType" transfer style="width: 140px">
          <Option v-for="item of doctypeData" :key="item.id" :value="item.id">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem label="MD5格式">
        <Select v-model="setinfo.transform" transfer style="width: 140px">
          <Option v-for="item of transData" :key="item.id" :value="item.id">{{ item.name }}</Option>
        </Select>
      </FormItem>
    </Form>
    <template slot="footer">
      <div class="m-foot">
        <Button @click="$emit('input', false)">取消</Button>
        <Button type="primary" :loading="loading" @click="save">
          <span v-if="loading">提交中...</span>
          <span v-else>确认</span>
        </Button>
      </div>
    </template>
  </Modal>
</template>
<script>
import { isEmpty } from '@/common/js/utils'
import AutoComplete from '@/components/autocomplete/autocomplete'
import InputNumberPlus from '@/components/input/input-number-plus'
import { initPageData, MEDIAS } from '@/data/global-opts'

const PAGE_REQUIRED_OPTS = initPageData([MEDIAS])
export default {
  name: 'setRecord',
  components: { AutoComplete, InputNumberPlus },
  props: {
    value: {
      type: Boolean
    },
    title: {
      type: String
    },
    loading: {
      type: Boolean
    },
    info: {
      type: Object
    },
    edit: {
      type: Boolean
    },
    equiData: {
      type: Array
    },
    doctypeData: {
      type: Array
    },
    transData: {
      type: Array
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    cusTitle() {
      return `${this.edit ? '修改' : '新增'}${this.title}`
    }
  },
  watch: {
    info: {
      handler(nVal) {
        this.updateInfo()
      },
      deep: true
    }
  },
  methods: {
    updateInfo() {
      this.$set(this, 'setinfo', this.info)
    },
    handleMedia(meta) {
      this.info.mediaId = meta.id
    },
    save() {
      if (isEmpty(this.setinfo.mediaId)) {
        this.$Message.error('媒体不能为空！')
        return
      }
      if (isEmpty(this.setinfo.maxCapacity) || !this.setinfo.maxCapacity) {
        this.$Message.error('包体最大限制不能为空！')
        return
      }
      if (isEmpty(this.setinfo.minNum) || !this.setinfo.minNum) {
        this.$Message.error('最低数量限制不能为空！')
        return
      }
      if (isEmpty(this.setinfo.maxNum) || !this.setinfo.maxNum) {
        this.$Message.error('最高数量限制不能为空！')
        return
      }
      this.$emit('on-save', this.setinfo)
    }
  },
  data() {
    return {
      setinfo: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.updateInfo()
    })
  }
}
</script>
<style lang="scss" scoped>
.ivu-form-item {
  margin-bottom: 15px;
  margin-right: 15px;
}

.c-unit {
  padding-left: 8px;
}
</style>
